import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class AssetHistoryApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public getHistories(
    id: ID,
    filter: FilterHistoryDAO
  ): Observable<PaginatedResponseDAO<HistoryDAO> & { metadata: { cleanUpDate: string } }> {
    const params = new HttpParams({
      fromObject: {
        offset: filter.offset,
        limit: filter.limit,
        ...(filter.keyword && { keyword: filter.keyword }),
        ...(filter.methods && { methods: filter.methods }),
        ...(filter.fromDateAt && { fromDateAt: filter.fromDateAt }),
        ...(filter.toDateAt && { toDateAt: filter.toDateAt })
      }
    });
    return this.httpClient.get<PaginatedResponseDAO<HistoryDAO> & { metadata: { cleanUpDate: string } }>(
      `${this.baseUrl}/assets/${id}/histories`,
      { params }
    );
  }

  public getHistoryById(assetId: ID, id: ID): Observable<HistoryDetailsDAO> {
    return this.httpClient.get<HistoryDetailsDAO>(`${this.baseUrl}/assets/${assetId}/histories/${id}`);
  }
}
